import script from "./CaseDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./CaseDetail.vue?vue&type=script&lang=ts&setup=true"

import "./CaseDetail.vue?vue&type=style&index=0&id=9e0c2590&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e0c2590"]])

export default __exports__